import React from 'react';

import { useWizardContext } from 'Views/Components/Wizard/WizardContext';
import { Button, Display } from 'Views/Components/Button/Button';

import { IStudyPlanWizardData } from 'Views/Pages/Frontend/StudyPlanWizard/StudyPlanWizard';

interface IPlanNavigationFooter {
	isMobile: boolean;
	isGeneratingPdf: boolean;
	selectedYear: number;
	currentlyViewingFinalYear: boolean;
	setSelectedYear: (newYear: number) => void,
	startingYear: number,
	exportToPdf: () => void,
}

const PlanNavigationFooter = ({
	isMobile,
	isGeneratingPdf,
	selectedYear,
	currentlyViewingFinalYear,
	setSelectedYear,
	startingYear,
	exportToPdf,
}: IPlanNavigationFooter) => {
	const {
		previousStep,
	} = useWizardContext<IStudyPlanWizardData>();

	return (
		<div className="steps-navigator">
			{isMobile ? (
				<>
					<div className="left">
						<Button
							className="btn--icon-only"
							display={Display.Solid}
							icon={{
								icon: 'arrow-back',
								iconPos: 'icon-left',
							}}
							disabled={selectedYear === 0}
							onClick={() => setSelectedYear(selectedYear - 1)}
						/>
					</div>
					<div className="center">
						<h6>{startingYear + selectedYear}</h6>
					</div>
				</>
			) : (
				<Button
					className="export-pdf-btn"
					icon={{
						icon: 'download',
						iconPos: 'icon-left',
					}}
					disabled={isGeneratingPdf}
					onClick={exportToPdf}
				>
					Export PDF
				</Button>
			)}
			<div className="right">
				{isMobile ? (
					<Button
						className="btn--icon-only"
						display={Display.Solid}
						icon={{
							icon: 'arrow-forward',
							iconPos: 'icon-right',
						}}
						disabled={currentlyViewingFinalYear}
						onClick={() => setSelectedYear(selectedYear + 1)}
					/>
				) : (
					<Button
						className="edit-selection-btn"
						icon={{
							icon: 'arrow-back',
							iconPos: 'icon-left',
						}}
						onClick={() => previousStep()}
					>
						Back
					</Button>
				)}
			</div>
		</div>
	);
};

export default PlanNavigationFooter;
